<template>
  <transition name="fade">
    <div class="mainContainerTable" v-show="mustShow">
      <div class="flatExportLoading" v-show="loadingFlatExport">
        <CenterCenter>{{ $t('player.flatExport.loading') }}<br/>
          {{ progressFlatExport }}%
        </CenterCenter>
      </div>
      <div class="videoContainer" style="animation-duration: 0.5s">
        <video oncontextmenu="return false;" disablePictureInPicture controlsList="nodownload noremoteplayback"
               playsinline ref="videoElement"
               class="videoElement"
               :src="urlOfNativePlayer" :poster="poster" controls
               @play="nativePlayerOnPlay" @pause="nativePlayerOnPause"
               @seeked="nativePlayerTimeUpdate" preload="metadata"
        />
      </div>
    </div>
  </transition>
</template>

<script lang="ts">
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import store from '@/store';
import {PLAYER_PLAYING, TIMER_PLAYER} from '@/store/timeLine/timeLineAction';
import {getThumbnailURL, getVideoURLForStatus} from '@/utils/util';
import {log} from '@/utils/log';
import {Weet} from '@/store/weet/weetModel';
import {getMediasForWeet} from '@/utils/weetUtil';
import {GET_EXPORTED_URL_WEET, LOAD_WEET_FOR_PLAYING} from '@/store/weet/weetAction';
import delay from "delay";
import CenterCenter from "@/components/layout/CenterCenter.vue";

@Component({
  components: {CenterCenter}
})
export default class NativeVideoPlayer extends Vue {
  @Prop()
  private weet!: Weet;
  @Prop({default: false})
  private nativePlayer!: boolean;
  private mustShow: boolean = false;
  private urlOfNativePlayer: string = '';
  private OFFSET_GENERIQUE: number = 0;
  private loadingFlatExport: boolean = false;
  private progressFlatExport = 0;

  // manage timestamp manually
  private interval: any = 0;
  private timeStep: number = 100;

  public mounted() {
    this.mustShow = true;
    this.getUrlOfNativePlayer();
  }

  public nativePlayerOnPlay() {
    this.interval = setInterval(this.nativePlayerTimeUpdate, this.timeStep);
    store.dispatch(PLAYER_PLAYING, true);
  }

  public nativePlayerOnPause() {
    clearInterval(this.interval);
    store.dispatch(PLAYER_PLAYING, false);
  }

  public nativePlayerTimeUpdate(value) {
    store.dispatch(TIMER_PLAYER, (this.videoElement.currentTime * 1000) - this.OFFSET_GENERIQUE);
  }


  // get the video HTML element
  get videoElement(): HTMLVideoElement {
    return this.$refs.videoElement as HTMLVideoElement;
  }


  get timePlayer(): number {
    return store.getters.getTimerPlayer + this.OFFSET_GENERIQUE;
  }

  get play(): boolean {
    return store.getters.isPlaying;
  }


  get poster(): string {
    const timeEventMedia = this.getTimeEvent();
    if (timeEventMedia === undefined) {
      return '';
    }
    let mediaID = timeEventMedia.mainMedia.mediaID;

    if (mediaID === '') {
      mediaID = timeEventMedia.secondMedia.mediaID;
    }

    const mediaFound = getMediasForWeet(this.weet, mediaID);
    if (mediaFound !== undefined) {
      return getThumbnailURL(mediaFound?.jobID, true);
    } else {
      return '';
    }
  }

  public getTimeEvent(): any {
    // we search the event with 0
    if (this.weet.timeLine.length > 0) {
      return this.weet.timeLine[0];
    } else {
      return undefined;
    }
  }

  public async getUrlOfNativePlayer() {
    try {
      let url = await store.dispatch(GET_EXPORTED_URL_WEET, {weetID: this.weet.weetID, download: false})
      const interval = 2000;
      const maxTime = 60 * 10 * 1000
      const dateEnd = new Date().getTime() + maxTime;
      this.loadingFlatExport = false;
      while (!url && dateEnd > new Date().getTime()) {
        this.loadingFlatExport = true;
        await delay(interval);
        // refresh weet
        const refreshWeet = await store.dispatch(LOAD_WEET_FOR_PLAYING, this.weet.weetID) as Weet
        this.progressFlatExport = refreshWeet.progressExport;
        if(this.progressFlatExport===100){
          url = await store.dispatch(GET_EXPORTED_URL_WEET, {weetID: refreshWeet.weetID, download: false})
        }
      }
      this.urlOfNativePlayer = url;
      this.loadingFlatExport = false;
      return url;
    } catch (e) {
      console.error(e);
    }
  }


  /**
   * change the status if play();
   */
  @Watch('play')
  public togglePlay() {
    if (this.play) {
      if (this.videoElement.paused) {
        this.videoElement.play().catch((e) => {
          log.debug(e);
        });
      }
    } else {
      this.videoElement.pause();
    }
  }

  @Watch('timePlayer')
  public onTimeChange() {
    // if there is an error of +/- 500 ms it's seek
    if (this.timePlayer > (this.videoElement.currentTime * 1000) + 500
        || this.timePlayer < (this.videoElement.currentTime * 1000) - 500) {
      this.videoElement.currentTime = this.timePlayer / 1000;
    }
  }

  /**
   * Remove url on destroy
   */
  public beforeDestroy() {
    this.videoElement.src = '';
    clearInterval(this.interval);
  }
}
</script>

<style scoped lang="scss">
@import "@/scss/shadows.scss";

.mainContainerTable {

  .videoContainer {
    font-size: 0; //remove incorect margin

    .videoElement {
      width: 100%;

    }
  }

  .flatExportLoading {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.6);
  }
}
</style>
